module.exports = __webpack_public_path__ + "static/media/S1N3-4.9d84ae6a.svg";